import { useEffect, useRef, useState } from "react";
import { ISearchBox } from "@fluentui/react";
import { IRegion, IRequestEstadoEquipo } from "../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { HistoricoEstadoEquipoService } from "../../../services/auxiliar/HistoricoEstadoEquipo";

export type keyType = "turnoKey" | "razonKey" | "ubicacionKey" | "equipoKey" | "estadoKey" | "tipoEquipoKey" | "regionKey"
export type textType = "tuernoText" | "razonText" | "ubicacionText" | "equipoText" | "estadoText" | "tipoEquipoText" | "regionText"


export interface IFilter2 {
  turnoKey: string,
  tuernoText: string
  razonKey: string,
  razonText: string
  ubicacionKey: string,
  ubicacionText: string
  equipoKey: string,
  equipoText: string,
  estadoKey: string[],
  estadoText: string[],
  tipoEquipoKey: string,
  tipoEquipoText: string,
  regionKey: string,
  regionText: string,

}

const initialFilter2: IFilter2 = {
  turnoKey: "",
  tuernoText: "",
  razonKey: "",
  razonText: "",
  ubicacionKey: "",
  ubicacionText: "",
  equipoKey: "",
  equipoText: "",
  estadoKey: [],
  estadoText: [],
  tipoEquipoKey: "",
  tipoEquipoText: "",
  regionKey: "",
  regionText: ""
}

export interface IT {
  key: keyType, keyValue: string, text: textType, textValue: string
}

export const UseEstadoEquipo = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<IRegion[]>([]);
  const onChangeSearch = useRef<ISearchBox>(null);
  const [control, setControl] = useState(true);
  const [filter2, setFilter2] = useState<IFilter2>({ ...initialFilter2 });
  const [filter, setFilter] = useState<IRequestEstadoEquipo>({
    search: "",
    estadosIds:[]
  });

  const _onkeyUpSearchTable = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  useEffect(() => {
    if (filter) {
      getEstadoEquipos();
    }
  }, [filter]);

  const initial: IRequestEstadoEquipo = {
    search: "",
    estadosIds:[]
  };

  const handleResetUpdate = () => {
    setFilter(initial);
  };

  const getEstadoEquipos = () => {
    setLoading(true);
    HistoricoEstadoEquipoService.ListarByEquipo(filter)
      .then((res) => {
        setLoading(false);
        setItems(res.data);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };

  const onChangeComboFilter = ({ key, keyValue, text, textValue }: IT) => {
    setFilter2((prevState) => ({
      ...prevState,
      [key]: keyValue,
      [text]: textValue,
    }));
  };
  interface ITI{
      key:string
      keys:string[]
      text:string,
      texts:string[]

  }
  const onChangeComboFilterMultiple = (props:ITI) => {
    setFilter2({...filter2,estadoKey:props.keys,estadoText:props.texts})
  };
 
 

  const buscar = () => {
    setFilter({
      search: "",
      estadosIds: filter2.estadoKey.length!=0 ? filter2.estadoKey : [],
      ubicacionId: filter2.ubicacionKey !== "" ? filter2.ubicacionKey : undefined,
      tipoEquipoId: filter2.tipoEquipoKey !== "" ? filter2.tipoEquipoKey : undefined,
      equipoId: filter2.equipoKey !== "" ? filter2.equipoKey : undefined,
      regionId: filter2.regionKey !== "" ? filter2.regionKey : undefined,
    });
    setControl(true);
  };
  const resetFilter2 = () => {
    setFilter2({ ...initialFilter2 });
    setFilter({
      search: "",
      estadosIds:[]
    });
    setControl(true);
  };

  useEffect(() => {
    if (control) {
      getEstadoEquipos();
      setControl(false);
    }
  }, [control]);




  return {
    loading,
    items,
    getEstadoEquipos,
    handleResetUpdate,
    filter,
    setFilter,
    onChangeSearch,
    _onkeyUpSearchTable,
    resetFilter2,
    buscar,
    onChangeComboFilter,
    filter2,
    onChangeComboFilterMultiple
  };
};
